import React from 'react'
import { connect } from 'react-redux'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'

import RevenueList from '../../components/RevenueList'
import DMPFilter from '../../components/DMPFilter'
import { RangeSelector } from './range-selector'
import { Preloader } from '../../components/Chart/index'

import moment from 'moment'
import debounce from 'lodash/debounce'
import './style.css'
import axios from 'axios'
import { dayStart, dayEnd, earlierDate } from '../../lib/format-date'
import { CSVDownload } from 'react-csv'
import ReactTooltip from 'react-tooltip'
import XLSX from 'xlsx'
import { formatCurrency, formatNumberTwoDigits } from '../../lib/format-number'
import { getDmp, getDmpProduct } from '../../lib/format-dmps'

class Revenue extends React.Component {
    state = {
        range: {
            type: 'current',
            startDate: null,
            endDate: null
        },
        size: 10,
        offset: 0,
        filter: '',
        sort: 'revenue_net',
        sortOrder: 'desc',
        dmp: '',
        dmpProduct: '',
        revenuesSummary: [],
        revenuesDetails: [],
        revenuesTotalsSummary: [],
        revenuesTotalsDetails: [],
        lastUpdated: null,
        csvData: null,
        reportType: 'summary'
    }

    loadRevenues() {
        this.debouncedSearchSummary(
            this.state.filter,
            this.state.size,
            this.state.offset,
            this.state.sort,
            this.state.sortOrder,
            this.state.range,
            this.state.dmp,
            this.state.dmpProduct, 
            true
        )
        this.debouncedSearchDetails(
            this.state.filter,
            this.state.size,
            this.state.offset,
            this.state.sort,
            this.state.sortOrder,
            this.state.range,
            this.state.dmp,
            this.state.dmpProduct,
            true
        )
    }

    onFilterChange(target) {
        console.log('onFilterChange', target.value, this)
        this.setState({ offset: 0, filter: target.value }, () => {
            this.loadRevenues()
        })
    }
    onDmpChange(dmp) {
        this.setState({ offset: 0, dmp: dmp, dmpProduct: '' })
    }
    onDmpProductChange(dmpProduct) {
        console.log('onDmpProductChange', dmpProduct)
        if (dmpProduct != null || dmpProduct != undefined) {
            this.setState({ offset: 0, dmpProduct: dmpProduct }, () => {
                this.loadRevenues()
            })
        }
    }
    onSortChange(sortField) {
        /*let sort = this.state.sort
        let sortOrder = this.state.sortOrder
        if (sort != sortField) {
            sortOrder = 'asc'
        } else {
            // toggle if is the same field
            sortOrder = sortOrder == 'asc' ? 'desc' : 'asc'
        }
        sort = sortField
        this.setState({ sort: sort, sortOrder: sortOrder, offset: 0 }, () => {
            this.loadRevenues()
        })*/
    }
    // used only in details pagination
    onLoadMoreDetails() {
        let offset = this.state.offset + this.state.size
        this.setState({ offset: offset }, () => {
            this.debouncedSearchDetails(
                this.state.filter,
                this.state.size,
                this.state.offset,
                this.state.sort,
                this.state.sortOrder,
                this.state.range,
                this.state.dmp,
                this.state.dmpProduct,
                false
            )
        })
    }

    componentDidMount() {
        this.debouncedSearchSummary = debounce(this.fetchRevenuesSummary, 300)
        this.debouncedSearchDetails = debounce(this.fetchRevenuesDetails, 300)
    }

    fetchRevenuesSummary(filter, size, offset, sort, sortOrder, range, dmp, dmpProduct, reset = true) {
        const { start, end } = this.findStartEnd(range)
        let revenuesSummary = this.state.revenuesSummary
        if(reset){
            revenuesSummary = []
        }
        this.setState(
            {
                revenuesSummary: revenuesSummary,
                revenuesTotalsSummary: [],
                revenueTotalsToday: [],
                revenueTotalsWeekly: [],
                revenueTotalsMonthly: [],
                loading: true
            },
            () => {
                axios
                    .get(
                        `/revenue/summary?dmp=${dmp}&dmpProduct=${dmpProduct}&offset=${offset}&size=${size}&filter=${filter}&sort=${sort}&sortOrder=${sortOrder}&start=${start}&end=${end}`
                    )
                    .then(response => {
                        console.log('revenues', response, response.data.body)
                        let newEvents = response.data.body.revenues

                        console.log('events', newEvents)
                        let oldEvents = this.state.revenuesSummary
                        oldEvents = oldEvents.concat(newEvents)

                        this.setState({
                            revenuesSummary: oldEvents,
                            revenuesTotalsSummary: response.data.body.revenueTotals,
                            revenueTotalsToday: response.data.body.revenueTotalsToday,
                            revenueTotalsWeekly: response.data.body.revenueTotalsWeekly,
                            revenueTotalsMonthly: response.data.body.revenueTotalsMonthly,
                            lastUpdated: response.data.body.lastUpdated,
                            loading: false
                        })
                    })
            }
        )
    }
    fetchRevenuesDetails(filter, size, offset, sort, sortOrder, range, dmp, dmpProduct, reset = true) {
        const { start, end } = this.findStartEnd(range)
        let revenuesDetails = this.state.revenuesDetails
        if(reset){
            revenuesDetails = []
        }
        this.setState({ 
            revenuesDetails: revenuesDetails,
            revenuesTotalsDetails: [],
            loading: true 
        }, () => {
            axios
                .get(
                    `/revenue?dmp=${dmp}&dmpProduct=${dmpProduct}&offset=${offset}&size=${size}&filter=${filter}&sort=${sort}&sortOrder=${sortOrder}&start=${start}&end=${end}`
                )
                .then(response => {
                    console.log('revenues', response, response.data.body)
                    let newEvents = response.data.body.revenues

                    console.log('events', newEvents)
                    let oldEvents = this.state.revenuesDetails
                    let concatEvents = oldEvents.concat(newEvents)
                    console.log('concat rows', concatEvents)

                    this.setState({
                        revenuesDetails: concatEvents,
                        revenuesTotalsDetails: response.data.body.revenueTotals,
                        lastUpdated: response.data.body.lastUpdated,
                        loading: false
                    })
                })
        })
    }

    //
    // Export XLS
    mapDataToCSVSummary(revenues, revenueTotals) {
        let csvData = []
        for (var i = 0; i < revenues.length; i++) {
            csvData.push({
                Product: getDmpProduct(revenues[i]['dmpProductId']),
                Market: getDmp(revenues[i]['market']),
                Impressions: revenues[i]['impressions'],
                Clicks: revenues[i]['clicks'],
                RevenueNet: revenues[i]['revenueNet'],
                RevenueGross: revenues[i]['revenueGross'],
                Currency: revenues[i]['currency']
            })
        }
        if (revenueTotals) {
            // make an empty row
            csvData.push({
                Product: '',
                Market: '',
                Impressions: '',
                Clicks: '',
                RevenueNet: '',
                RevenueGross: '',
                Currency: ''
            })
            for (var i = 0; i < revenueTotals.length; i++) {
                let title = i == 0 ? 'TOTALS' : ''
                // then add all totals x currency
                csvData.push({
                    Product: '',
                    Market: '',
                    Impressions: revenueTotals[i]['impressions'],
                    Clicks: revenueTotals[i]['clicks'],
                    RevenueNet: revenueTotals[i]['revenueNet'],
                    RevenueGross: revenueTotals[i]['revenueGross'],
                    Currency: revenueTotals[i]['currency']
                })
            }
        }
        return csvData
    }
    mapDataToCSVDetails(revenues, revenueTotals) {
        let csvData = []
        for (var i = 0; i < revenues.length; i++) {
            csvData.push({
                'Audience Id': revenues[i]['arListId'],
                'Audience Name': revenues[i]['audienceName'],
                'License Id': revenues[i]['licenseId'],
                'License Name': revenues[i]['licenseName'],
                Product: getDmpProduct(revenues[i]['dmpProductId']),
                Market: getDmp(revenues[i]['market']),
                Impressions: revenues[i]['impressions'],
                Clicks: revenues[i]['clicks'],
                RevenueNet: revenues[i]['revenueNet'],
                RevenueGross: revenues[i]['revenueGross'],
                Currency: revenues[i]['currency']
            })
        }
        if (revenueTotals) {
            // make an empty row
            csvData.push({
                'Audience Id': '',
                'Audience Name': '',
                'License Id': '',
                'License Name': '',
                Product: '',
                Market: '',
                Impressions: '',
                Clicks: '',
                RevenueNet: '',
                RevenueGross: '',
                Currency: ''
            })
            for (var i = 0; i < revenueTotals.length; i++) {
                let title = i == 0 ? 'TOTALS' : ''
                // then add all totals x currency
                csvData.push({
                    'Audience Id': title,
                    'Audience Name': '',
                    'License Id': '',
                    'License Name': '',
                    Product: '',
                    Market: '',
                    Impressions: revenueTotals[i]['impressions'],
                    Clicks: revenueTotals[i]['clicks'],
                    RevenueNet: revenueTotals[i]['revenueNet'],
                    RevenueGross: revenueTotals[i]['revenueGross'],
                    Currency: revenueTotals[i]['currency']
                })
            }
        }
        return csvData
    }

    onCSVExport() {
        const { start, end } = this.findStartEnd(this.state.range)

        this.setState({ loading: true, csvData: null }, () => {
            let url = `/revenue?dmp=${this.state.dmp}&dmpProduct=${this.state.dmpProduct}&offset=0&size=1000&filter=${this.state.filter}&sort=${this.state.sort}&sortOrder=${this.state.sortOrder}&start=${start}&end=${end}`
            if (this.state.reportType == 'summary') {
                url = `/revenue/summary?dmp=${this.state.dmp}&dmpProduct=${this.state.dmpProduct}&offset=0&size=1000&filter=${this.state.filter}&sort=${this.state.sort}&sortOrder=${this.state.sortOrder}&start=${start}&end=${end}`
            }

            axios.get(url).then(response => {
                console.log('revenues', response, response.data.body)

                let jsonData = {}
                if (this.state.reportType == 'summary') {
                    jsonData = this.mapDataToCSVSummary(response.data.body.revenues, response.data.body.revenueTotals)
                } else {
                    jsonData = this.mapDataToCSVDetails(response.data.body.revenues, response.data.body.revenueTotals)
                }
                this.setState({
                    loading: false
                })
                let fileName = 'ExportRevenue-from ' + start + ' to ' + end + '.xls'
                this.exportToXSL(jsonData, fileName)
            })
        })
    }

    exportToXSL(jsonData, fileName) {
        let ws_name = 'Revenue Export'
        let ws = XLSX.utils.json_to_sheet(jsonData)

        // create a new workbook
        let wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, ws_name)

        // then save in XLS 2003 excel binary format so it will be super compatible!
        let type = 'biff8'
        XLSX.writeFile(wb, fileName || 'SheetJSTableExport.' + (type || 'xlsx'))
    }

    findStartEnd(range) {
        let start, end

        switch (range.type) {
            case 'custom':
                start = dayStart(range.startDate).format('YYYY-MM-DD')
                end = earlierDate(dayEnd(range.endDate), moment()).format('YYYY-MM-DD')
                break
            case 'last':
                const month = moment().month()
                start = dayStart(
                    moment()
                        .month(month - 1)
                        .date(1)
                ).format('YYYY-MM-DD')
                end = dayEnd(moment().date(0)).format('YYYY-MM-DD')
                break
            case 'current':
            default:
                start = dayStart(moment().date(1)).format('YYYY-MM-DD')
                end = moment().format('YYYY-MM-DD')
                break
        }

        return { start, end }
    }

    handleRangeChange(newRange) {
        const oldRange = this.state.range

        if (newRange.type !== 'custom' && newRange.type === oldRange.type) return
        else if (newRange.type === 'custom' && newRange.startDate === oldRange.startDate && newRange.endDate === oldRange.endDate) return

        this.setState({ revenuesDetails: [], revenuesSummary: [], offset: 0, range: newRange }, () => {
            this.fetchRevenuesSummary(
                this.state.filter,
                this.state.size,
                this.state.offset,
                this.state.sort,
                this.state.sortOrder,
                newRange,
                this.state.dmp,
                this.state.dmpProduct
            )
            this.fetchRevenuesDetails(
                this.state.filter,
                this.state.size,
                this.state.offset,
                this.state.sort,
                this.state.sortOrder,
                newRange,
                this.state.dmp,
                this.state.dmpProduct
            )
        })
    }

    render() {
        const { range } = this.state
        return (
            <PageWrapper>
                <div className="container-fluid">
                    {/* 
                    <div className="row">
                        <div className="col-12">
                            <WhiteBox>
                                <div className="row">
                                    <div className="col">
                                        <h3>Filter revenues</h3>
                                    </div>
                                </div>

                                           
                                <div className="row">
                                    <div className="col-12">
                                        <div className="add-segment add-segment--search-field">
                                            <input
                                                className="form-control"
                                                placeholder="Start typing a license name, license id or audience id..."
                                                onChange={({ target }) => this.onFilterChange(target)}
                                            />
                                        </div>
                                    </div>
                                </div>
                               

                                <DMPFilter
                                    showAllProductOption="true"
                                    onDmpChange={this.onDmpChange.bind(this)}
                                    onDmpProductChange={this.onDmpProductChange.bind(this)}
                                />
                            </WhiteBox>
                        </div>
                    </div>
                     */}

                    {this.state.loading && <Preloader transparent />}

                    {/* revenue report */}
                    <div className="row">
                        <div className="col-lg-12">
                            <WhiteBox customStyle={{ overflow: 'visible' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 20 }}>
                                    <h3 className="box-title">Revenue Report</h3>

                                    <div style={{ flex: 1 }} />
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <span style={{ 'font-size': '12px', color: '#888' }}>Today</span>
                                        <br />
                                        <h3 className="box-title">
                                            {this.state.revenueTotalsToday && this.state.revenueTotalsToday.length > 0 && (
                                                <span style={{ 'font-size': '20px' }}>
                                                    {formatCurrency(this.state.revenueTotalsToday[0].revenueNet, this.state.revenueTotalsToday[0].currency)}
                                                </span>
                                            )}
                                            {!(this.state.revenueTotalsToday && this.state.revenueTotalsToday.length > 0) && <span>-</span>}
                                        </h3>
                                    </div>
                                    <div className="col">
                                        <span style={{ 'font-size': '12px', color: '#888' }}>This week</span>
                                        <br />
                                        <h3 className="box-title">
                                            {this.state.revenueTotalsWeekly && this.state.revenueTotalsWeekly.length > 0 && (
                                                <span style={{ 'font-size': '20px' }}>
                                                    {formatCurrency(this.state.revenueTotalsWeekly[0].revenueNet, this.state.revenueTotalsWeekly[0].currency)}
                                                </span>
                                            )}
                                            {!(this.state.revenueTotalsWeekly && this.state.revenueTotalsWeekly.length > 0) && <span>-</span>}
                                        </h3>
                                    </div>
                                    <div className="col">
                                        <span style={{ 'font-size': '12px', color: '#888' }}>This month</span>
                                        <br />
                                        <h3 className="box-title">
                                            {this.state.revenueTotalsMonthly && this.state.revenueTotalsMonthly.length > 0 && (
                                                <span style={{ 'font-size': '20px' }}>
                                                    {formatCurrency(this.state.revenueTotalsMonthly[0].revenueNet, this.state.revenueTotalsMonthly[0].currency)}
                                                </span>
                                            )}
                                            {!(this.state.revenueTotalsMonthly && this.state.revenueTotalsMonthly.length > 0) && <span>-</span>}
                                        </h3>
                                    </div>
                                    <div className="col-6" style={{ top: '-50px' }}>
                                        <DMPFilter
                                            showAllProductOption="true"
                                            onDmpChange={this.onDmpChange.bind(this)}
                                            onDmpProductChange={this.onDmpProductChange.bind(this)}
                                        />
                                    </div>
                                </div>
                            </WhiteBox>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <WhiteBox customStyle={{ overflow: 'visible' }}>
                                <RangeSelector range={range} onChangeRange={range => this.handleRangeChange(range)} />
                                <br />

                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item">
                                        <a
                                            onClick={() => this.setState({ reportType: 'summary' })}
                                            className="nav-link active"
                                            id="summary-tab"
                                            data-toggle="tab"
                                            href="#summary"
                                            role="tab"
                                            aria-controls="summary"
                                            aria-selected="true">
                                            Summary
                                            <br />
                                            <span style={{ 'font-size': '12px', color: '#888' }}>Breakdown by product</span>
                                        </a>
                                    </li>
                                    <li className="nav-item" data-toggle="tab">
                                        <a
                                            onClick={() => this.setState({ reportType: 'details' })}
                                            className="nav-link"
                                            id="details-tab"
                                            data-toggle="tab"
                                            href="#details"
                                            role="tab"
                                            aria-controls="details"
                                            aria-selected="false">
                                            Details
                                            <br />
                                            <span style={{ 'font-size': '12px', color: '#888' }}>Breakdown by license</span>
                                        </a>
                                    </li>
                                </ul>
                                <div
                                    className="text-right"
                                    style={{
                                        position: 'relative',
                                        top: '-50px',
                                        width: '50%',
                                        right: '0%',
                                        left: '50%'
                                    }}>
                                    {this.state.lastUpdated && (
                                        <span style={{ fontSize: 'smaller', color: 'grey' }}>
                                            Last Updated:{' '}
                                            {moment(this.state.lastUpdated, 'YYYY-MM-DD')
                                                .toDate()
                                                .toLocaleDateString()}
                                        </span>
                                    )}
                                    &#160;&#160;
                                    <ReactTooltip id="exportCSVRevenuesBtnTooltip" type="dark" effect="solid">
                                        <span>Export as Excel XLS File</span>
                                    </ReactTooltip>
                                    {/*
                                        <CSVLink data={this.state.csvData} filename={'revenue-export.csv'} data-tip data-for="exportCSVRevenuesBtnTooltip" >
                                            <i
                                                className="fa fa-file-excel-o fa-3"
                                                style={{ fontSize: '20px', top: '2px', position: 'relative', color: 'green' }}></i>
                                        </CSVLink>
                                        */}
                                    <button
                                        className="border-button inlinebuttons "
                                        data-tip
                                        data-for="exportCSVRevenuesBtnTooltip"
                                        href="#"
                                        onClick={() => this.onCSVExport()}>
                                        <i className="fa fa-file-excel-o fa-3" style={{ fontSize: '20px', top: '2px', position: 'relative' }}></i>&#160; Export
                                    </button>
                                    {/* render only if we have csv data */}
                                    {this.state.csvData != null && <CSVDownload filename={'revenue-export.csv'} data={this.state.csvData} />}
                                </div>

                                {/* tabs */}
                                <div className="tab-content tab-content-revenue">
                                    <div className="tab-pane fade show active" id="summary" role="tabpanel" aria-labelledby="summary-tab">
                                        {this.state.reportType == 'summary' && (
                                            <RevenueList
                                                loading={this.props.loading}
                                                onLoadMore={this.onLoadMoreDetails.bind(this)}
                                                offset={this.state.offset}
                                                size={this.state.size}
                                                revenues={this.state.revenuesSummary}
                                                sort={this.state.sort}
                                                sortOrder={this.state.sortOrder}
                                                onSortChange={this.onSortChange.bind(this)}
                                                reportType={this.state.reportType}
                                                revenueTotals={this.state.revenuesTotalsSummary}
                                            />
                                        )}
                                    </div>
                                    <div className="tab-pane fade " id="details" role="tabpanel" aria-labelledby="details-tab">
                                        {this.state.reportType == 'details' && (
                                            <RevenueList
                                                loading={this.props.loading}
                                                onLoadMore={this.onLoadMoreDetails.bind(this)}
                                                offset={this.state.offset}
                                                size={this.state.size}
                                                revenues={this.state.revenuesDetails}
                                                sort={this.state.sort}
                                                sortOrder={this.state.sortOrder}
                                                onSortChange={this.onSortChange.bind(this)}
                                                reportType={this.state.reportType}
                                                revenueTotals={this.state.revenuesTotalsDetails}
                                            />
                                        )}
                                    </div>
                                </div>
                            </WhiteBox>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        )
    }
}

export default connect()(Revenue)
